import fetch from "auth/FetchInterceptor";

const crmService = {};

// ========================
// Colunas kanban
// ========================

crmService.getColunas = async function () {
	return fetch({
		url: "/v1/rest/crm-coluna-kanban",
		method: "get",
	});
};

crmService.createColuna = async function (data) {
	return fetch({
		url: "/v1/rest/crm-coluna-kanban",
		method: "post",
		data,
	});
};

crmService.updateColuna = async function (id, data) {
	return fetch({
		url: `/v1/rest/crm-coluna-kanban/${id}`,
		method: "put",
		data,
	});
};

crmService.reordenarColunas = async function (ordens) {
	return fetch({
		url: "/v1/rest/crm-coluna-kanban/reordenar",
		method: "put",
		data: { ordens },
	});
};

crmService.deleteColuna = async function (id) {
	return fetch({
		url: `/v1/rest/crm-coluna-kanban/${id}`,
		method: "delete",
	});
};

// ========================
// Leads
// ========================

crmService.getVendedores = async function () {
	return fetch({
		url: "/v1/rest/crm-vendedor",
		method: "get",
	});
};

crmService.getLeads = async function (params = {}) {
	return fetch({
		url: "/v1/rest/crm-lead",
		method: "get",
		params,
	});
};

crmService.getLeadById = async function (id) {
	return fetch({
		url: `/v1/rest/crm-lead/${id}`,
		method: "get",
	});
};

crmService.createLead = async function (data) {
	return fetch({
		url: "/v1/rest/crm-lead",
		method: "post",
		data,
	});
};

crmService.updateLead = async function (id, data) {
	return fetch({
		url: `/v1/rest/crm-lead/${id}`,
		method: "put",
		data,
	});
};

crmService.moverLead = async function (data) {
	return fetch({
		url: "/v1/rest/crm-lead/mover",
		method: "put",
		data,
	});
};

crmService.importarLeads = async function (data) {
	return fetch({
		url: "/v1/rest/crm-lead/importar",
		method: "post",
		data,
	});
};

crmService.registrarAcessoCheckout = async function () {
	return fetch({
		url: "/v1/rest/crm-lead/registrar-acesso",
		method: "post",
	});
};

crmService.deleteLead = async function (id) {
	return fetch({
		url: `/v1/rest/crm-lead/${id}`,
		method: "delete",
	});
};

// ========================
// Notas
// ========================

crmService.getNotas = async function (idCrmLead) {
	return fetch({
		url: "/v1/rest/crm-lead-nota",
		method: "get",
		params: { id_crm_lead: idCrmLead },
	});
};

crmService.createNota = async function (data) {
	return fetch({
		url: "/v1/rest/crm-lead-nota",
		method: "post",
		data,
	});
};

crmService.deleteNota = async function (id) {
	return fetch({
		url: `/v1/rest/crm-lead-nota/${id}`,
		method: "delete",
	});
};

// ========================
// Tags
// ========================

crmService.getTags = async function () {
	return fetch({
		url: "/v1/rest/crm-tag",
		method: "get",
	});
};

crmService.createTag = async function (data) {
	return fetch({
		url: "/v1/rest/crm-tag",
		method: "post",
		data,
	});
};

crmService.updateTag = async function (id, data) {
	return fetch({
		url: `/v1/rest/crm-tag/${id}`,
		method: "put",
		data,
	});
};

crmService.deleteTag = async function (id) {
	return fetch({
		url: `/v1/rest/crm-tag/${id}`,
		method: "delete",
	});
};

// ========================
// Lead-Tag
// ========================

crmService.attachTag = async function (data) {
	return fetch({
		url: "/v1/rest/crm-lead-tag",
		method: "post",
		data,
	});
};

crmService.detachTag = async function (idCrmLead, idCrmTag) {
	return fetch({
		url: "/v1/rest/crm-lead-tag",
		method: "delete",
		params: { id_crm_lead: idCrmLead, id_crm_tag: idCrmTag },
	});
};

// ========================
// Comissão Config
// ========================

crmService.getComissaoConfigs = async function (params = {}) {
	return fetch({
		url: "/v1/rest/crm-comissao-config",
		method: "get",
		params,
	});
};

crmService.salvarComissaoConfig = async function (data) {
	return fetch({
		url: "/v1/rest/crm-comissao-config",
		method: "post",
		data,
	});
};

// ========================
// Vendas
// ========================

crmService.getVendas = async function (params = {}) {
	return fetch({
		url: "/v1/rest/crm-venda",
		method: "get",
		params,
	});
};

crmService.marcarVendaPaga = async function (id) {
	return fetch({
		url: `/v1/rest/crm-venda/${id}/pagar`,
		method: "put",
	});
};

export default crmService;
